module.exports = __webpack_public_path__ + "static/media/staff.fw.b141646d.png";